const getErrorClass = (errors, fieldName) => {
  return errors[fieldName] ? "not-value" : "";
};

const validateField = (formData, fieldName, errorMessage, errors) => {
  if (formData[fieldName]?.length === 0) {
    errors[fieldName] = errorMessage;
    return false;
  }

  errors[fieldName] = undefined;
  return true;
};

const focusField = (ref) => {
  if (ref.current) {
    ref.current.focus();
  }
};

export { getErrorClass, validateField, focusField };